import React from 'react';
import {
  BrowserRouter, Redirect, Route, Switch,
} from 'react-router-dom';
import Login from '../screens/Login';
import Dashboard from '../screens/Dashboard';
import AddNewLead from '../components/Leads/AddNewLead';
import AddNewPlan from '../components/Plans/AddNewPlan';
import NewUpworkProposalLead from '../components/Leads/NewUpworkProposalLead';
import SkillList from '../components/Skills/SkillList';
import LeadsList from '../components/Leads/LeadsList';
import EditLead from '../components/Leads/EditLead';
import ShowSelectedLead from '../components/Leads/ShowSelectedLead';
import SetUpWorkLeadData from '../components/Leads/SetUpWorkLeadData';
import LeadClassification from '../components/Leads/LeadClassification';
import SetFirstMessage from '../components/Leads/SetFirstmessage';
import GotAnswered from '../components/Leads/GotAnswered';
import CloseLead from '../components/Leads/Closelead';
import OpenLead from '../components/Leads/Openlead';
import AddCommentLead from '../components/Leads/AddComment';
import PlanList from '../components/Plans/PlansList';
import FineDone from '../components/Leads/FineDone';
import DealLead from '../components/Leads/DealLead';
import RawDone from '../components/Leads/RawDone';
import NotQualifiedLead from '../components/Leads/NotQualified';

export default function RouterInner() {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/login" component={Login} />
        <Route
          path="/"
          render={() => (
            <Dashboard>
              <Route exact path="/new-lead" render={(props) => <AddNewLead {...props} />} />
              <Route exact path="/new-plan" render={(props) => <AddNewPlan {...props} />} />
              <Route exact path="/new-upwork-proposal-lead" render={(props) => <NewUpworkProposalLead {...props} />} />
              <Route exact path="/lead-list" render={(props) => <LeadsList {...props} />} />
              <Route exact path="/plans-list" render={(props) => <PlanList {...props} />} />
              <Route
                exact
                path="/actions/set-upwork-data"
                render={(props) => <LeadsList {...props} actionType={14} />}
              />
              <Route
                exact
                path="/actions/set-lead-classification"
                render={(props) => <LeadsList {...props} actionType={6} />}
              />
              <Route
                exact
                path="/actions/set-first-message"
                render={(props) => <LeadsList {...props} actionType={7} />}
              />
              <Route
                exact
                path="/actions/got-answered"
                render={(props) => <LeadsList {...props} actionType={2} />}
              />
               <Route
                    exact
                    path="/actions/finedone-lead"
                    render={(props) => <LeadsList {...props} actionType={20} />}
                />
                <Route
                    exact
                    path="/actions/rawdone-lead"
                    render={(props) => <LeadsList {...props} actionType={25} />}
                />
              <Route exact path="/lead/:id" render={(props) => <ShowSelectedLead {...props} />} />
              <Route exact path="/lead/update/:id" render={(props) => <EditLead {...props} />} />
              <Route exact path="/actions/set-upwork-data/:id" render={(props) => <SetUpWorkLeadData {...props} />} />
                <Route exact path="/actions/set-first-message/:id" render={(props) => <SetFirstMessage {...props} />} />
                <Route exact path="/actions/got-answered/:id" render={(props) => <GotAnswered {...props} />} />
                <Route exact path="/actions/close-lead/:id" render={(props) => <CloseLead {...props} />} />
              <Route exact path="/actions/open-lead/:id" render={(props) => <OpenLead {...props} />} />
              <Route exact path="/actions/comments-lead/:id" render={(props) => <AddCommentLead {...props} />} />
              <Route exact path="/actions/set-lead-classification/:id" render={(props) => <LeadClassification {...props} />} />
              <Route exact path="/developers-availability" render={(props) => <SkillList {...props} />} />
                <Route exact path="/actions/finedone-lead/:id" render={(props) => <FineDone {...props} />} />
                <Route exact path="/actions/rawdone-lead/:id" render={(props) => <RawDone {...props} />} />
                <Route exact path="/actions/deal-lead/:id" render={(props) => <DealLead {...props} />} />
                <Route exact path="/actions/not-qualified-lead/:id" render={(props) => <NotQualifiedLead {...props} />} />
            </Dashboard>
          )}
        />
        <Redirect to="/" />
      </Switch>
    </BrowserRouter>
  );
}
